import { z } from 'zod/v4'
export const ReduxActionSchema = z.object({ type: z.string() }).loose()

export type ReduxAction = z.infer<typeof ReduxActionSchema>
